export default class CustomerDataHandler {
  constructor() {
    var buttons = document.querySelectorAll('.btn-customer-popup');
    buttons.forEach(button => {
      button.addEventListener('click', this.loadCustomerPopup.bind(this));
    });
  }

  loadCustomerPopup() {
    com.parkside.loader.show(false, false);
    jQuery.ajax({
      url: window.customerDataFormUrl,
      success: function (popup) {
        jQuery.fancybox({
          modal: false,
          content: popup,
          width: 'auto',
          height: 'auto',
          scrolling: 'no',
          transitionOut: 'none',

          onStart: function () {
            jQuery('body').css({ overflow: 'hidden' });
            if (jQuery('#fancybox-wrap').parent('.fancybox-wrap-no-scroll').length <= 0) {
              jQuery('#fancybox-wrap').wrap(
                jQuery("<div class='fancybox-wrap-no-scroll'></div>").bind('click', function (e) {
                  if (jQuery(e.target).is('.fancybox-wrap-no-scroll')) {
                    jQuery('#fancybox-close').trigger('click');
                  }
                })
              );
            }
            jQuery('#fancybox-close').append('<span class="fa fa-times fa-lg"></span>');
          },
          onComplete: function () {
            com.parkside.loader.hide();
          },
          onClosed: function () {
            if (jQuery('#fancybox-wrap').parent('.fancybox-wrap-no-scroll').length) {
              jQuery('#fancybox-wrap').unwrap();
            }
            jQuery('body').css({ overflow: '' });
          },
        });
      },
      error: function () {
        com.parkside.loader.hide();
      },
    });
  }
}
